// extracted by mini-css-extract-plugin
module.exports = {"container":"PageHeading_container__3Jwyh","page-title":"PageHeading_page-title__Kc9N_","page-sub-title":"PageHeading_page-sub-title__RgIlo"};